// extracted by mini-css-extract-plugin
module.exports = {"tagsContainer":"TableCellTags-tagsContainer-1N8RRy","loading":"TableCellTags-loading-1x0mVq"};